<template>
  <div class="blur-date-filter-wrapper" data-qa-id="blur-date-filter-wrapper">
    <button class="btn--blur">
      <span class="calendar-icon" />
      <span class="blur-date-filter" data-qa-id="default-date-filter"> {{ $t('pages.dashboard.components.dateSelectDropdown.select_dates') }} </span>
    </button>
  </div>
</template>

<style lang="scss" src="./stylesheet/index.scss" />
